/* TD Draft 2026-09-29 PDPF — product-page weight module (sections/td-pdp-weight.liquid, loaded only by that section).
   Animation 1 "Die Schwere legt sich" + slider from the homepage module, made product-specific:
   - The weight engine (geometry, easing, beads, one-time intro, nudge) is a COPY of assets/td-home.js section 1, so the
     homepage module keeps its own behaviour. parseRange() is the copy of assets/custom.js (D07) — keep them identical.
   - Candidates = this product's variants that share every option the buyer has selected in the buy box except the weight
     (size, Bezugsart; on the set both covers). Complete variant list from the section JSON (products ≤ 250 variants); for a
     capped product (set: 400 combinations) the section is re-rendered for the new selection (option_values, like Prestige).
   - Recommendation: the tightest AVAILABLE range containing the body weight (sold-out variants with overlapping ranges are never
     recommended); only sold-out ranges match → the nearest LIGHTER available weight that has its own range + note (never a
     heavier one: review 29.09., kids 22 kg must not get 5 kg for 41–50 kg); no lighter one → the matching weight as sold out,
     button 'Auswahl ändern' + other sizes of the same kind (children's / adult sizes); no range → note, no weight.
     Two matching ranges: tighter, then lower upper end, then the weight selected in the buy box, then lighter (tight()).
   - The theme's Gewichtshilfe popup (assets/custom.js D07) and this module show the same body weight: 'Berechnen' / Enter /
     'X kg auswählen' in the popup move this slider (review 29.09.: popup 95 kg → 10 kg, the module must not keep offering 8 kg).
   - Filling label: 'Reißverschluss' in a selected option value or in the product title → Edelstahlkügelchen (Felix 29.09.).
   - The button clicks the real option input of the buy box (Prestige's own variant logic runs), then scrolls back to the weight
     option and focuses it once the picker has been swapped. Follows every variant change (variant:change on the main form).
   - Reduced motion / Save-Data: no intro, every change instant. The server markup is the complete end state; reserved heights
     keep the page still while dragging. Runs once per section (data-td-init); set up again after a theme-editor re-render.
   - TD 2026-10-11 UX-PDP #18: − / + buttons ([data-pw-step]) move the slider by 1 kg and run userInput() like a drag
     (recommendation, chips, button, live announcement 'Bei X kg Körpergewicht …'); aria-disabled at min / max (syncSteps). */
(function () {
  'use strict';
  if (window.tdPdpWeightBooted) return;
  window.tdPdpWeightBooted = true;
  var w = window, d = document, conn = navigator.connection, NB = '\u00a0';
  var mq = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: no-preference)') : null;
  function motionOK() { return !!(mq && mq.matches) && !(conn && conn.saveData); }
  var bags = [], onReduce = [];
  function bag(root) { var b = { r: root, fns: [] }; bags.push(b); return b; }
  if (mq) {
    var mqChange = function () { if (!motionOK()) onReduce.forEach(function (o) { o.f(); }); };
    if (mq.addEventListener) mq.addEventListener('change', mqChange); else if (mq.addListener) mq.addListener(mqChange);
  }
  function once(el, thr, fn, b) {
    if (!('IntersectionObserver' in w)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        if (es[i].isIntersecting && es[i].intersectionRatio >= thr * 0.98) { io.disconnect(); fn(); return; }
      }
    }, { threshold: thr });
    io.observe(el);
    if (b) b.fns.push(function () { io.disconnect(); });
  }
  var hashEl = null;
  try { hashEl = w.location.hash.length > 1 ? d.getElementById(decodeURIComponent(w.location.hash.slice(1))) : null; } catch (e) { hashEl = null; }
  /* intro only when the module starts below the viewport and is not the target of a deep link */
  function armIfBelow(el) {
    if (!motionOK()) return false;
    if (hashEl && el.contains(hashEl)) return false;
    return el.getBoundingClientRect().top > w.innerHeight;
  }
  function nbu(s) { return String(s).replace(/(\d) (kg|cm)(?![\w\u00c0-\u024f])/g, '$1' + NB + '$2').replace(/ ›/g, NB + '›'); }
  function tpl(s, o) { return nbu(String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return o[k] != null ? o[k] : m; })); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function all(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function cssEsc(v) { return w.CSS && CSS.escape ? CSS.escape(String(v)) : String(v).replace(/["\\]/g, '\\$&'); }

  /* ---------------------------------------------------------------- engine: copy of assets/td-home.js section 1 */
  var X0 = 70, X1 = 350, N = 64, T = 10, BED = 150, P = 8, PW = (X1 - X0) / P, SVGNS = 'http://www.w3.org/2000/svg';
  var XS = [], HB = [], HL = [];
  function geom() {
    if (XS.length) return;
    var i, j;
    var g = function (x, c, s) { var q = (x - c) / s; return Math.exp(-q * q); };
    for (i = 0; i <= N; i++) { XS.push(X0 + (X1 - X0) * i / N); HB.push(34 * g(XS[i], 100, 34) + 46 * g(XS[i], 192, 50) + 24 * g(XS[i], 288, 46)); }
    for (i = 0; i <= N; i++) { var m = 0; for (j = 0; j <= N; j++) { var q = XS[j] - XS[i]; m = Math.max(m, HB[j] - 0.0035 * q * q); } HL.push(m); }
  }
  function kOf(kg) { return Math.min(0.95, Math.max(0.3, 0.3 + (kg - 5) / 7 * 0.65)); }
  function nOf(kg) { return Math.max(2, Math.round(3 + (kg - 5) * 0.55)); }
  function settled(kg) { var k = kOf(kg), a = []; for (var i = 0; i <= N; i++) a.push(BED - (HL[i] + (HB[i] - HL[i]) * k)); return a; }
  function floating() { var a = []; for (var i = 0; i <= N; i++) a.push(52 + 4 * Math.sin(XS[i] / 26)); return a; }
  function yAt(a, x) { var f = (x - X0) / (X1 - X0) * N, i = Math.max(0, Math.min(N - 1, Math.floor(f))), t = f - i; return a[i] + (a[i + 1] - a[i]) * t; }
  function ease(t) { var u = t - 1; return 1 + 1.55 * u * u * u + 0.55 * u * u; } /* soft landing, about 1% overshoot */
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function r1(v) { return Math.round(v * 10) / 10; }
  /* copy of parseRange() in assets/custom.js (D07) — keep both identical; snippets/td-pdpf-range.liquid follows the same rules */
  function parseRange(text) {
    if (!text) return null;
    var t = String(text).replace(/<[^>]*>/g, '').split(':').pop().split('.')[0].replace(/–/g, '-');
    var m = t.match(/(\d+)\s*-\s*(\d+)/);
    if (m) return [Number(m[1]), Number(m[2])];
    m = t.match(/(\d+)\s*kg\s*\+/i) || t.match(/ab\s*(\d+)/i);
    if (m) return [Number(m[1]), Infinity];
    m = t.match(/bis\s*(\d+)/i);
    if (m) return [0, Number(m[1])];
    /* TD 2026-10-01 INTL-PDP — translated texts ('Up to 69 kg', 'Jusqu'à 69 kg', 'Fino a 69 kg', 'Tot 69 kg', '110 kg et plus',
       '31 à 40 kg'): same language-independent fallback as snippets/td-pdpf-range.liquid — two numbers = range, one number
       with '+' or a 'from' word = open end, any other single number = 'up to'. German texts always match the rules above. */
    var n = t.replace(/[\u00a0\u202f]/g, ' ').match(/\d+/g);
    if (n && n.length >= 2 && Number(n[1]) > Number(n[0])) return [Number(n[0]), Number(n[1])];
    if (n && n.length) {
      if (FROM_RE.test(t)) return [Number(n[0]), Infinity];
      if (Number(n[0]) > 0) return [0, Number(n[0])];
    }
    return null;
  }
  var FROM_RE = /\+|(^|[^a-z\u00c0-\u024f])(ab|über|from|over|above|more|plus|partir|dès|desde|más|mas|da|oltre|più|piu|vanaf|meer|boven)([^a-z\u00c0-\u024f]|$)/i;

  function initWeight(root, b) {
    root.classList.add('td-js');
    var data = JSON.parse(root.querySelector('[data-td-pw-data]').textContent);
    var t0 = data.t, WP = data.w, SP = data.s;
    if (!WP || !data.sel) throw new Error('td-pdp weight: data');
    var q = function (s) { return root.querySelector(s); };
    var range = q('[data-pw-range]'), val = q('[data-pw-val]'), chips = q('[data-pw-chips]'), res = q('[data-pw-result]'),
      live = q('[data-pw-live]'), cta = q('[data-pw-cta]'), hint = q('[data-pw-hint]'), badge = q('[data-pw-badge]'),
      badgeG = q('[data-pw-badge-g]'), stage = q('[data-pw-stage]'), blanket = q('[data-pw-blanket]'), beadG = q('[data-pw-beads]'),
      label = q('[data-pw-label] path'), labelText = q('[data-pw-label-text]'), heading = q('[data-pw-heading]'), text = q('[data-pw-text]'),
      sLabel = q('[data-pw-slabel]'), kNote = q('[data-pw-kids-note]'), notes = q('[data-pw-notes]');
    if (!range || !blanket || !res || !cta || !chips || !notes) throw new Error('td-pdp weight: markup');
    var stitches = all(root, '[data-pw-stitches] line');
    var steps = all(root, '[data-pw-step]'); /* TD 2026-10-11 UX-PDP #18 */
    var mode = root.classList.contains('is-kids') ? 'kids' : 'adults', touched = false, introDone = false, chipsFor = null;
    var recKg = null, shownKg = null, ctx = null, lastO = null, awaiting = null, fetchN = 0, fid = null, helperBw = null;
    var liveT = 0, visT = 0, badgeT = 0, rsT = 0, awaitT = 0, raf = 0, cur = null, beads = [], nBeads = 0, LT = [], lastW = 0;
    var seed = 7, rnd = function () { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };

    /* ---- variants: [id, options, available, price, range text] */
    var known = {};
    function kgOf(s) { var m = String(s || '').match(/(\d+(?:[.,]\d+)?)/); return m ? parseFloat(m[1].replace(',', '.')) : NaN; }
    function mk(a) {
      var r = parseRange(a[4]), o = a[1] || [];
      return { id: a[0], o: o, a: !!a[2], p: a[3], lo: r ? r[0] : -1, hi: r ? r[1] : -1, wv: o[WP - 1], kg: kgOf(o[WP - 1]), s: SP ? o[SP - 1] : '' };
    }
    /* a variant without the metafield borrows the range of a sibling with the same size + weight (as D07) */
    function learn(list) { list.forEach(function (v) { var k = v.s + '|' + v.wv; if (v.lo >= 0 && !known[k]) known[k] = [v.lo, v.hi]; }); }
    function lend(list) { list.forEach(function (v) { var r = known[v.s + '|' + v.wv]; if (v.lo < 0 && r) { v.lo = r[0]; v.hi = r[1]; } }); }
    var allV = data.v ? data.v.map(mk) : null, selV = data.sel.map(mk);
    if (allV) learn(allV);
    learn(selV);
    if (allV) lend(allV);
    lend(selV);

    /* ---- the buy box */
    function picker() {
      return d.querySelector('variant-picker[context="main_product"][handle="' + cssEsc(data.handle) + '"]') ||
        d.querySelector('.shopify-section--main-product variant-picker[form-id]');
    }
    function formId() {
      if (fid && d.forms[fid]) return fid;
      var p = picker();
      fid = p ? p.getAttribute('form-id') : null;
      return fid;
    }
    function inputs(pos, checkedOnly) {
      var f = formId();
      return f ? all(d, 'input[data-option-position' + (pos ? '="' + pos + '"' : '') + '][form="' + cssEsc(f) + '"]' + (checkedOnly ? ':checked' : '')) : [];
    }
    function readSel() {
      var s = {};
      inputs(0, true).forEach(function (i) { s[i.getAttribute('data-option-position')] = i.getAttribute('data-option-value') || ''; });
      (data.cur || []).forEach(function (v, i) { if (s[i + 1] == null) s[i + 1] = v; });
      return s;
    }
    function othersKey(s) { var k = []; for (var p = 1; p <= 3; p++) if (p !== WP) k.push(s[p] == null ? '' : s[p]); return k.join('|'); }
    function sameOthers(v, s) {
      for (var p = 1; p <= v.o.length; p++) { if (p !== WP && s[p] != null && v.o[p - 1] !== s[p]) return false; }
      return true;
    }
    function candidates(s) { return (allV || selV).filter(function (v) { return sameOthers(v, s); }); }
    function modeOf(c) {
      var n = 0, mx = 0;
      c.forEach(function (v) { if (v.lo >= 0) { n++; mx = Math.max(mx, v.hi); } });
      return n && mx <= data.m.kids.max ? 'kids' : 'adults';
    }

    /* ---- recommendation */
    function inR(bw) { return function (v) { return v.lo >= 0 && v.lo <= bw && bw <= v.hi; }; }
    /* TD Draft 2026-09-29 PDPF (review fix) — order of the matching ranges (same in the Liquid first paint): tightest range,
       then the lower upper end (open end counts as 999, as in Liquid), then the weight already selected in the buy box (two
       weights with the SAME range, e.g. Balance Inlett 135 × 200 cm 6 kg and 8 kg both '50 - 69': the one the visitor picked,
       also via 'X kg auswählen' in the Gewichtshilfe popup, stays the recommendation), then the lighter weight */
    function hiC(v) { return Math.min(v.hi, 999); }
    function tight(a, c) {
      var ws = ctx && ctx.s ? ctx.s[WP] : null;
      return ((hiC(a) - a.lo) - (hiC(c) - c.lo)) || (hiC(a) - hiC(c)) || ((c.wv === ws) - (a.wv === ws)) || (a.kg - c.kg);
    }
    /* TD Draft 2026-09-29 PDPF (review fix) — the fallback for a sold-out matching weight is only ever LIGHTER and only a
       variant with its own range (Grau 90 × 120 has a 12 kg variant without one); no lighter one → 'gone' (no button target) */
    function pickIn(c, bw) {
      if (!c.length) return { f: 'none' };
      var av = c.filter(function (v) { return v.a; });
      var ha = av.filter(inR(bw)).sort(tight);
      if (ha.length) return { v: ha[0], tkg: ha[0].kg };
      var h = c.filter(inR(bw)).sort(tight);
      if (!av.length) return { f: 'soldout', tkg: h.length ? h[0].kg : null };
      if (!h.length) return { f: 'none' };
      var tkg = h[0].kg, best = null;
      av.forEach(function (x) { if (x.lo >= 0 && x.kg < tkg && (!best || x.kg > best.kg)) best = x; });
      return best ? { v: best, tkg: tkg, f: 'next' } : { f: 'gone', tkg: tkg };
    }
    /* other sizes of this product (same other options) with an available matching weight — only with the complete list.
       TD Draft 2026-09-29 PDPF (review fix): only sizes of the same kind (children's sizes for a child, adult sizes for an adult):
       a 25 kg child must not be sent to 150 × 220 cm, whose 6 kg is listed 'Bis 49 kg' (Gravity Inlett). */
    function otherSizes(bw, s) {
      if (!allV || !SP) return [];
      var by = {}, keys = [], o = [];
      allV.forEach(function (v) {
        if (v.s === s[SP]) return;
        for (var p = 1; p <= v.o.length; p++) { if (p !== WP && p !== SP && s[p] != null && v.o[p - 1] !== s[p]) return; }
        if (!by[v.s]) { by[v.s] = []; keys.push(v.s); }
        by[v.s].push(v);
      });
      keys.forEach(function (k) {
        if (modeOf(by[k]) === mode && by[k].some(function (v) { return v.a && inR(bw)(v); })) o.push(k);
      });
      return o;
    }
    function fmtSize(s) { return String(s).replace(/ x /g, NB + '×' + NB).replace(/ cm$/, NB + 'cm'); }
    function kgT(kg) { return kg + NB + 'kg'; }
    function joinAnd(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' ' + t0.and + ' ' + a[a.length - 1]; }
    function chipsOf(vs) {
      var o = [], seen = {};
      vs.forEach(function (v) { var k = v.lo + '^' + v.hi + '^' + v.kg; if (v.lo >= 0 && !seen[k]) { seen[k] = 1; o.push(v); } });
      return o.sort(function (a, c) { return (a.lo - c.lo) || (a.hi - c.hi) || (a.kg - c.kg); });
    }
    function compute(bw) {
      var s = ctx.s, c = ctx.c, m = pickIn(c, bw), o = { notes: [], m: m };
      var size = SP ? s[SP] : '';
      o.kg = m.v ? m.v.kg : (m.tkg != null ? m.tkg : null);
      o.sub = m.v ? (size ? tpl(t0.at, { size: fmtSize(size) }) + ' · ' : '') + m.v.p : '';
      if (m.f === 'next') o.notes.push(tpl(t0.next, { kg: m.tkg, next: m.v.kg }));
      else if (m.f === 'soldout') o.notes.push(t0.soldout);
      else if (m.f === 'gone') o.notes.push(tpl(t0.gone, { kg: m.tkg }));
      else if (m.f === 'none') o.notes.push(size ? tpl(t0.none, { bw: bw, size: fmtSize(size) }) : tpl(t0.noneNoSize, { bw: bw }));
      if (m.f === 'none' || m.f === 'gone' || m.f === 'soldout') {
        var os = otherSizes(bw, s);
        if (os.length && t0.other) o.notes.push(tpl(t0.other, { sizes: joinAnd(os.map(fmtSize)) }));
      }
      if (m.v) o.cta = m.v.wv === s[WP] ? { st: 'selected', t: tpl(t0.ctaSel, { kg: m.v.kg }) } : { st: 'select', t: tpl(t0.cta, { kg: m.v.kg }), v: m.v };
      else o.cta = { st: 'change', t: t0.ctaChange };
      if (o.cta.st === 'selected' && t0.sel) o.ok = tpl(t0.sel, { kg: m.v.kg });
      /* children's slider at its upper end: point to the adult blankets */
      o.above = mode === 'kids' && bw >= Number(range.max) && !!t0.above;
      return o;
    }
    function chipText(v) {
      if (v.lo === 0) return t0.to + ' ' + kgT(v.hi);
      if (v.hi === Infinity) return t0.from + ' ' + kgT(v.lo);
      return v.lo + '–' + v.hi;
    }
    /* TD Draft 2026-09-29 PDPF (review fix) — recommendation + price above the button, notes below it. Only the result block and
       the button keep a reserved height (the button never moves under the finger); the notes under the button grow and shrink
       with the slider — a shift caused by the visitor's own input (not counted as CLS) instead of up to 260px of empty card
       (review 29.09.: Einhorn 90 × 120 had a 140px gap between price and button). */
    function resHTML(o) {
      return '<p class="td-pw__rec">' + esc(t0.rec) + ' <strong>' + (o.kg != null ? kgT(o.kg) : '–') + '</strong></p>' +
        (o.sub ? '<p class="td-pw__sub">' + esc(o.sub) + '</p>' : '') +
        (o.ok ? '<p class="td-pw__ok">' + esc(o.ok) + '</p>' : '');
    }
    function notesHTML(o) {
      return o.notes.map(function (n) { return '<p class="td-pw__note">' + esc(n) + '</p>'; }).join('') +
        (o.above ? '<p class="td-pw__note">' + esc(t0.above) + (t0.aboveLink && t0.aboveUrl ? ' <a href="' + esc(t0.aboveUrl) + '">' + esc(nbu(t0.aboveLink)) + '</a>' : '') + '</p>' : '');
    }
    /* reserve the tallest result block and button of the whole slider range: the slider, result and button stay put while dragging */
    function reserve() {
      if (!ctx) return;
      var mn = Number(range.min), mx = Number(range.max), seen = {}, hr = 0, hc = 0, keepR = res.innerHTML, keepC = cta.textContent;
      res.style.minHeight = '';
      cta.style.minHeight = '';
      for (var bw = mn; bw <= mx; bw++) {
        var o = compute(bw), a = resHTML(o);
        if (!seen['r' + a]) { seen['r' + a] = 1; res.innerHTML = a; hr = Math.max(hr, res.offsetHeight); }
        if (!seen['c' + o.cta.t]) { seen['c' + o.cta.t] = 1; cta.textContent = o.cta.t; hc = Math.max(hc, cta.offsetHeight); }
      }
      res.innerHTML = keepR;
      cta.textContent = keepC;
      if (hr) res.style.minHeight = hr + 'px';
      if (hc) cta.style.minHeight = hc + 'px';
    }
    function onResize() {
      if (root.offsetWidth === lastW) return;
      clearTimeout(rsT);
      rsT = setTimeout(function () { lastW = root.offsetWidth; reserve(); }, 150);
    }
    function fillBar() {
      var mn = Number(range.min), mx = Number(range.max);
      range.style.setProperty('--p', (mx > mn ? (Number(range.value) - mn) / (mx - mn) * 100 : 0) + '%');
      syncSteps();
    }
    /* TD 2026-10-11 UX-PDP #18 — − / + buttons: dimmed at the slider's ends (aria-disabled, so a focused button keeps focus) */
    function syncSteps() {
      steps.forEach(function (bt) {
        var st = Number(bt.getAttribute('data-pw-step')) || 0, v = Number(range.value);
        var off = st < 0 ? v <= Number(range.min) : v >= Number(range.max);
        if (off) bt.setAttribute('aria-disabled', 'true'); else bt.removeAttribute('aria-disabled');
      });
    }
    function renderText(announce) {
      if (!ctx) return null;
      var bw = Number(range.value), o = compute(bw);
      lastO = o;
      val.textContent = kgT(bw);
      range.setAttribute('aria-valuetext', bw + ' kg');
      fillBar();
      if (chipsFor !== ctx) {
        chipsFor = ctx;
        var av = ctx.c.filter(function (v) { return v.a; });
        chips.innerHTML = chipsOf(av.length ? av : ctx.c).map(function (v) { return '<li data-kg="' + v.kg + '"><span>' + esc(chipText(v)) + '</span><b>' + kgT(v.kg) + '</b></li>'; }).join('');
      }
      all(chips, 'li').forEach(function (li) { li.classList.toggle('is-on', Number(li.getAttribute('data-kg')) === o.kg); });
      res.innerHTML = resHTML(o);
      notes.innerHTML = notesHTML(o);
      cta.textContent = o.cta.t;
      cta.setAttribute('data-state', o.cta.st);
      recKg = o.kg;
      setBadge(o.kg);
      if (announce) {
        clearTimeout(liveT);
        liveT = setTimeout(function () { live.textContent = liveText(o, bw); }, 450);
      }
      return o;
    }
    /* TD Draft 2026-09-29 FIX-0929d (review PDP-F9) — the screen-reader announcement says what the card shows: with a
       recommended weight that is not available ('gone' / 'soldout', e.g. Balance Inlett 90 × 120 cm at 22 kg: 'Unsere Empfehlung:
       3 kg' + '3 kg ist … nicht lieferbar') it no longer claims 'keine passende Stufe'; the notes under the button are read as well */
    function liveText(o, bw) {
      var n = o.notes.join(' ');
      if (o.m.v) return tpl(t0.live, { bw: bw, kg: o.m.v.kg }) + (n ? ' ' + n : '');
      if (o.kg != null) return t0.rec + ' ' + kgT(o.kg) + '.' + (n ? ' ' + n : '');
      return n || tpl(t0.liveNone || '', { bw: bw });
    }
    function setBadge(kg) {
      if (badgeG) badgeG.classList.toggle('is-off', kg == null);
      if (!badge || kg == null || kg === shownKg) return;
      var first = shownKg === null;
      shownKg = kg;
      clearTimeout(badgeT);
      if (first || !motionOK()) { badge.textContent = kgT(kg); badge.style.opacity = ''; return; }
      badge.style.opacity = '0';
      badgeT = setTimeout(function () { badge.textContent = kgT(kg); badge.style.opacity = ''; }, 150);
    }
    function applyMode() {
      var m = data.m[mode], k = mode === 'kids';
      root.classList.toggle('is-kids', k);
      range.min = m.min;
      range.max = m.max;
      range.value = m.start;
      if (helperBw != null) setBw(helperBw); /* TD Draft 2026-09-29 PDPF (review fix): the body weight typed in the popup stays */
      if (heading) heading.textContent = (k && t0.headK) || t0.headA;
      if (text) text.textContent = (k && t0.textK) || t0.textA || '';
      if (sLabel) sLabel.textContent = (k && t0.sliderK) || t0.sliderA;
      if (kNote) kNote.hidden = !k;
    }
    /* zip closure = Edelstahlkügelchen: a selected option value OR the product title names it (Felix 29.09.: "Füllung bei
       Inlett mit Reißverschluss ist Edelstahl!" — same rule as the Liquid first paint, no placeholder) */
    function applyLabel(s) {
      if (!labelText) return;
      var zip = !!t0.zipAll; /* the product title names the zip closure */
      for (var p in s) if (t0.zipKw && String(s[p]).indexOf(t0.zipKw) > -1) zip = true;
      /* TD 2026-10-01 INTL-PDP — translated storefronts: the zip value of the cover-type option, by position (Liquid zipPos/zipVal) */
      if (t0.zipPos && t0.zipVal && s[t0.zipPos] === t0.zipVal) zip = true;
      labelText.textContent = (zip && t0.labelZip) || t0.label || '';
    }

    /* ---- graphic (copy of assets/td-home.js) */
    function buildBeads(n, fall) {
      beadG.textContent = '';
      beads = [];
      for (var p = 0; p < P; p++) {
        for (var bi = 0; bi < n; bi++) {
          var c = d.createElementNS(SVGNS, 'circle');
          c.setAttribute('r', '2.2');
          beadG.appendChild(c);
          beads.push({ p: p, b: bi, n: n, el: c, fx: rnd(), fy: rnd(), fall: fall });
        }
      }
      nBeads = n;
    }
    function frame(from, to, t) {
      var yb = [], dmax = 1e-6, i, top = '', bot = '';
      for (i = 0; i <= N; i++) dmax = Math.max(dmax, to[i] - from[i]);
      for (i = 0; i <= N; i++) {
        var ti = 0.45 + 0.55 * Math.max(0, to[i] - from[i]) / dmax; /* peaks touch down first, valleys last */
        LT[i] = ti;
        yb.push(from[i] + (to[i] - from[i]) * ease(clamp(t / ti)));
      }
      for (i = 0; i <= N; i++) top += (i ? 'L' : 'M') + r1(XS[i]) + ' ' + r1(yb[i] - T);
      for (i = N; i >= 0; i--) bot += 'L' + r1(XS[i]) + ' ' + r1(yb[i]);
      blanket.setAttribute('d', top + bot + 'Z');
      for (i = 0; i < stitches.length; i++) {
        var sx = X0 + (i + 1) * PW, sy = yAt(yb, sx);
        stitches[i].setAttribute('y1', r1(sy - T + 1.5));
        stitches[i].setAttribute('y2', r1(sy - 0.5));
      }
      for (i = 0; i < beads.length; i++) {
        var o = beads[i], rx = X0 + o.p * PW + PW * (o.b + 0.5) / o.n, x = rx, e = 1, ylo;
        if (o.fall) {
          var li = Math.round((o.p + 0.5) * PW / (X1 - X0) * N), bt = clamp((t - LT[li] * 0.8) / 0.35);
          e = bt < 1 ? 1 - Math.pow(1 - bt, 3) : 1;
          var fx = X0 + o.p * PW + 3 + o.fx * (PW - 6);
          x = fx + (rx - fx) * e;
        }
        ylo = yAt(yb, x);
        var ys = ylo - T + 3 + o.fy * (T - 6), y = o.fall ? ys + ((ylo - 3.4) - ys) * e : ylo - 3.4;
        o.el.setAttribute('cx', r1(x));
        o.el.setAttribute('cy', r1(y));
      }
      if (label) { var lx = X0 + 1.5 * PW; label.setAttribute('d', 'M' + lx + ' ' + r1(yAt(yb, lx) - T - 2) + 'L' + lx + ' 26L' + (lx + 6) + ' 26'); }
      return yb;
    }
    function play(from, to, dur, done) {
      cancelAnimationFrame(raf);
      var start = 0;
      var step = function (now) {
        if (!start) start = now;
        var t = clamp((now - start) / dur);
        cur = frame(from, to, t);
        if (t < 1) { raf = requestAnimationFrame(step); return; }
        raf = 0;
        beads.forEach(function (bd) { bd.fall = false; });
        if (done) done();
      };
      raf = requestAnimationFrame(step);
    }
    function draw(kg) {
      cancelAnimationFrame(raf);
      raf = 0;
      if (kg == null) kg = shownKg || 6; /* no weight for this selection: still land the blanket (never left floating) */
      var n = nOf(kg), to = settled(kg);
      if (n !== nBeads) buildBeads(n, false);
      beads.forEach(function (bd) { bd.fall = false; });
      cur = frame(to, to, 1);
    }
    function visual(kg, animate) {
      if (kg == null) return;
      if (!introDone) return; /* the intro (still ahead) settles on the current recommendation */
      if (!animate || !motionOK() || !cur) { draw(kg); return; }
      var lift = cur.map(function (y) { return y - 7; }), n = nOf(kg);
      if (n !== nBeads) buildBeads(n, true);
      play(lift, settled(kg), 900);
    }
    function inView() { var r = stage.getBoundingClientRect(); return r.bottom > 0 && r.top < w.innerHeight; }
    function finish() {
      if (hint) hint.classList.remove('is-nudge');
      root.classList.add('is-labeled');
      introDone = true;
      clearTimeout(visT);
      draw(recKg);
    }
    function nudge() {
      if (touched || !motionOK() || !hint) return;
      hint.classList.add('is-nudge');
      hint.addEventListener('animationend', function () { hint.classList.remove('is-nudge'); }, { once: true });
    }
    function intro() {
      if (touched || !motionOK()) { finish(); return; }
      var fl = floating();
      visT = setTimeout(function () {
        if (touched || !motionOK() || recKg == null) { finish(); return; }
        var kg0 = recKg;
        play(fl, settled(kg0), 2600, function () {
          root.classList.add('is-labeled');
          introDone = true;
          if (recKg !== kg0) draw(recKg); /* the selection changed during the intro */
          visT = setTimeout(nudge, 900);
        });
      }, 250);
    }
    function userInput() {
      touched = true;
      helperBw = null;
      if (!introDone) finish();
      root.classList.add('is-labeled');
      var o = renderText(true);
      clearTimeout(visT);
      visT = setTimeout(function () { visual(recKg, true); }, 120);
      return o;
    }

    /* ---- follow the buy box */
    function setCtx(s, c) {
      var nm = modeOf(c), before = recKg;
      ctx = { s: s, c: c, key: othersKey(s) };
      if (nm !== mode) { mode = nm; applyMode(); }
      applyLabel(s);
      renderText(false);
      reserve();
      if (recKg !== before) visual(recKg, inView());
    }
    function fetchSel() {
      var ids = inputs(0, true).sort(function (a, c) { return Number(a.getAttribute('data-option-position')) - Number(c.getAttribute('data-option-position')); }).map(function (i) { return i.value; });
      if (!ids.length || !w.fetch || !w.DOMParser) return;
      var my = ++fetchN;
      root.setAttribute('aria-busy', 'true');
      fetch(data.url + '?option_values=' + encodeURIComponent(ids.join(',')) + '&section_id=' + encodeURIComponent(data.sid))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (my !== fetchN || !root.isConnected) return;
          var sc = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-td-pw-data]');
          if (!sc) throw new Error('td-pdp weight: re-render');
          selV = JSON.parse(sc.textContent).sel.map(mk);
          learn(selV);
          lend(selV);
          root.removeAttribute('aria-busy');
          var s = readSel();
          setCtx(s, candidates(s));
        })
        .catch(function (e) { if (my === fetchN) root.removeAttribute('aria-busy'); if (w.console && console.warn) console.warn(e); });
    }
    function refresh() {
      var s = readSel(), key = othersKey(s);
      if (ctx && key === ctx.key) {
        var before = recKg;
        ctx.s = s;
        renderText(false); /* only the weight changed: the button state follows (and a same-range tie follows the selection) */
        if (recKg !== before) visual(recKg, inView());
      } else {
        var c = candidates(s);
        if (!allV && !c.length) fetchSel(); /* capped variant list: the section re-render brings this selection */
        else setCtx(s, c);
      }
      if (awaiting) settle();
    }
    function onVariant(e) {
      var f = formId();
      /* the product form has an input named "id": read the attribute, not form.id */
      if (!f || !e.target || !e.target.getAttribute || e.target.getAttribute('id') !== f) return;
      refresh();
    }
    d.addEventListener('variant:change', onVariant);

    /* ---- TD Draft 2026-09-29 PDPF (review fix): the Gewichtshilfe popup of the same buy box sets this slider too.
       Its 'Berechnen' button, Enter in its field and its 'X kg auswählen' button move the slider to the typed body weight, so
       module and popup show the same weight (review 29.09.: popup 95 kg → 10 kg while the module kept offering 8 kg). A body
       weight outside the slider (a child's weight on an adult blanket, an adult's on a children's blanket) widens the slider
       to it instead of clamping — clamped, the module would answer for another body weight than the popup. */
    function setBw(bw) {
      if (bw < Number(range.min)) range.min = bw;
      if (bw > Number(range.max)) range.max = bw;
      range.value = bw;
    }
    function fromHelper(h) {
      var inp = h.querySelector('.td-weight-helper__input');
      var bw = inp ? Math.round(parseFloat(String(inp.value).replace(',', '.'))) : NaN;
      if (!(bw >= 1 && bw <= 300)) return; /* empty or a typo: the popup shows its own message; keep the slider */
      helperBw = bw;
      var mn = range.min, mx = range.max;
      if (bw === Number(range.value)) return;
      setBw(bw);
      root.classList.add('is-labeled');
      renderText(false);
      if (range.min !== mn || range.max !== mx) reserve();
      if (introDone) draw(recKg); /* the popup covers the module: no animation; an intro still ahead settles on it */
    }
    function helperOf(el) {
      var h = el && el.closest ? el.closest('.td-weight-helper') : null, f = formId();
      return h && f && h.getAttribute('data-form-id') === f ? h : null;
    }
    function onHelperClick(e) {
      var t = e.target && e.target.closest ? e.target.closest('.td-weight-helper__calc-btn, .td-weight-helper__apply') : null;
      var h = t && helperOf(t);
      if (h) fromHelper(h);
    }
    function onHelperKey(e) {
      if (e.key !== 'Enter' || !e.target || !e.target.matches || !e.target.matches('.td-weight-helper__input')) return;
      var h = helperOf(e.target);
      if (h) fromHelper(h);
    }
    d.addEventListener('click', onHelperClick, true);
    d.addEventListener('keydown', onHelperKey, true);

    /* ---- actions */
    function headerOffset() {
      var h = d.querySelector('.shopify-section--header');
      var o = h && /sticky|fixed/.test(getComputedStyle(h).position) ? h.offsetHeight : 0;
      if (!o) { var hh = d.querySelector('.shopify-section--header .header, header'); if (hh && /sticky|fixed/.test(getComputedStyle(hh).position)) o = hh.offsetHeight; }
      return o + 12;
    }
    function scrollToEl(el, center) {
      if (!el) return;
      var r = el.getBoundingClientRect(), top = center ? r.top + w.pageYOffset - (w.innerHeight - r.height) / 2 : r.top + w.pageYOffset - headerOffset();
      w.scrollTo({ top: Math.max(0, top), behavior: motionOK() ? 'smooth' : 'auto' });
    }
    function box(pos) {
      var i = inputs(pos)[0];
      return i ? i.closest('fieldset') || i.parentNode : picker();
    }
    function focusChecked(pos) {
      var i = inputs(pos, true)[0];
      if (i) { try { i.focus({ preventScroll: true }); } catch (e) { i.focus(); } }
    }
    function settle() {
      var a = awaiting;
      awaiting = null;
      clearTimeout(awaitT);
      if (!a) return;
      var bx = box(WP);
      if (bx) {
        var r = bx.getBoundingClientRect();
        if (r.top < 0 || r.top > w.innerHeight * 0.6) scrollToEl(bx); /* the swap moved it: put it back in view */
      }
      focusChecked(WP);
      var s = readSel();
      if (s[WP] === a.wv) live.textContent = tpl(t0.done, { kg: a.kg });
    }
    function selectWeight(v) {
      var inp = inputs(WP).filter(function (i) { return i.getAttribute('data-option-value') === v.wv; })[0];
      scrollToEl(box(WP));
      if (!inp || inp.disabled) { focusChecked(WP); return; }
      awaiting = { kg: v.kg, wv: v.wv };
      clearTimeout(awaitT);
      awaitT = setTimeout(settle, 4000); /* no swap arrived (request failed): focus the option anyway */
      if (inp.checked) settle(); else inp.click(); /* the theme's own change handler selects the variant */
    }
    function toCart() {
      var f = formId(), btn = f && (d.querySelector('#' + cssEsc(f) + ' [type="submit"]') || d.querySelector('[form="' + cssEsc(f) + '"][type="submit"]'));
      if (!btn) { scrollToEl(box(WP)); focusChecked(WP); return; }
      scrollToEl(btn, true);
      try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); }
    }
    cta.addEventListener('click', function () {
      var o = lastO;
      if (!o) return;
      if (o.cta.st === 'select') selectWeight(o.cta.v);
      else if (o.cta.st === 'selected') toCart();
      else { var pos = SP || 1; scrollToEl(box(pos)); focusChecked(pos); }
    });

    range.addEventListener('input', userInput);
    range.addEventListener('keydown', function (e) {
      var st = e.key === 'PageUp' ? 10 : e.key === 'PageDown' ? -10 : 0;
      if (!st) return;
      e.preventDefault();
      var v = Math.max(Number(range.min), Math.min(Number(range.max), Number(range.value) + st));
      if (v !== Number(range.value)) { range.value = v; userInput(); }
    });
    /* TD 2026-10-11 UX-PDP #18 — 1 kg per tap; the same path as dragging (userInput: text, chips, button, badge, live region,
       blanket animation). touch-action: manipulation in the CSS keeps a quick double tap from zooming the page. */
    steps.forEach(function (bt) {
      bt.addEventListener('click', function () {
        var st = Number(bt.getAttribute('data-pw-step')) || 0;
        var v = Math.max(Number(range.min), Math.min(Number(range.max), Number(range.value) + st));
        if (st && v !== Number(range.value)) { range.value = v; userInput(); }
      });
    });
    onReduce.push({ r: root, f: finish });
    b.fns.push(function () {
      clearTimeout(liveT); clearTimeout(visT); clearTimeout(badgeT); clearTimeout(rsT); clearTimeout(awaitT); cancelAnimationFrame(raf);
      w.removeEventListener('resize', onResize); d.removeEventListener('variant:change', onVariant); fetchN++;
      d.removeEventListener('click', onHelperClick, true); d.removeEventListener('keydown', onHelperKey, true);
    });

    /* ---- start: the context of the page as rendered (the buy box may already differ after a quick change) */
    geom();
    var s0 = readSel(), c0 = candidates(s0);
    if (!c0.length && !allV) { s0 = {}; (data.cur || []).forEach(function (v, i) { s0[i + 1] = v; }); c0 = candidates(s0); }
    ctx = { s: s0, c: c0, key: othersKey(s0) };
    var m0 = modeOf(c0);
    if (m0 !== mode) { mode = m0; applyMode(); }
    applyLabel(s0);
    renderText(false);
    lastW = root.offsetWidth;
    reserve();
    w.addEventListener('resize', onResize, { passive: true });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { if (root.isConnected) reserve(); });
    if (armIfBelow(root) && recKg != null) {
      root.classList.add('is-armed');
      var fl = floating();
      buildBeads(nOf(recKg), true);
      cur = frame(fl, fl, 0);
      once(stage, 0.5, intro, b);
    } else {
      finish();
    }
    if (othersKey(readSel()) !== ctx.key) refresh();
  }

  /* ---------------------------------------------------------------- boot */
  function safe(fn, root) {
    var b = bag(root);
    try { fn(root, b); } catch (e) {
      root.classList.remove('td-js'); /* back to the complete server state (no-JS layout) */
      if (w.console && console.warn) console.warn(e);
    }
  }
  function boot(scope) {
    scope = scope || d;
    var list = all(scope, '[data-td-pw]');
    if (scope.matches && scope.matches('[data-td-pw]')) list.unshift(scope);
    list.forEach(function (el) {
      if (el.getAttribute('data-td-init')) return;
      el.setAttribute('data-td-init', '1');
      safe(initWeight, el);
    });
  }
  function cleanup(scope) {
    bags = bags.filter(function (b) {
      if (!scope.contains(b.r)) return true;
      b.fns.forEach(function (f) { try { f(); } catch (e) { /* ignore */ } });
      return false;
    });
    onReduce = onReduce.filter(function (o) { return !scope.contains(o.r); });
  }
  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  d.addEventListener('shopify:section:unload', function (e) { cleanup(e.target); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { boot(d); }); else boot(d);
})();
